import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/GetList?` + params, null);

export const getStockReportExportFile = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockExportFile?` + params, null);

export const GetStockSummaryBySupplierList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockSummaryBySupplierList?` + params, null);

export const GetStockSummaryByBuyerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockSummaryByBuyerList?` + params, null);

export const GetStockDetailByBuyerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockDetailByBuyerList?` + params, null);

export const GetStockSummaryByProductAndBuyerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockSummaryByProductAndBuyerList?` + params, null);

export const GetStockSummaryDetailByProductAndBuyerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockSummaryDetailByProductAndBuyerList?` + params, null);

export const GetStockByCategoryList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockByCategoryList?` + params, null);

export const GetStockAdjList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/StockAdjustment/GetList?` + params, null);

export const CreateStockAdjustment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/StockAdjustment/Create`, data)

export const UpdateStockAdjustment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/StockAdjustment/Update`, data);

export const GetStockAdjustmentDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/StockAdjustment/GetDetail?` + params, null);

export const GetStockAdjNumber = (params: any) =>
   GET_ENC(`${BASE_URL}/api/StockAdjustment/GetStockAdjNumber?` + params, null);

export const DeleteStockAdjustment = (data: any) =>
  POST_ENC(`${BASE_URL}/api/StockAdjustment/Delete`, data);

export const GetStockBatchWiseList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockBatchWiseList?` + params, null);

export const GetExpiredStock = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/stockExpiredList?` + params, null);


export const GetNearExpirydStock = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/NearExpirydStock?` + params, null);


export const GetLowQuantityStock = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/LowQuantity?` + params, null);

export const GetStockByWarehouseList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockByWarehouseList?` + params, null);

export const GetStockLedgerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockLedgerList?` + params, null);

export const GetStockSummaryLedgerList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Stock/StockSummaryLedgerList?` + params, null);

